import React from 'react'
import { TextField, Button, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { closePopup } from 'app/redux/actions/PopupAlertActions'
import { useLocation, useNavigate } from 'react-router-dom'
import { deleteItemDetails, getItemDetails, upsertItemDetails } from 'app/redux/actions/TableListingActions'

export default function PopupAlert() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { popupAlert } = useSelector((state) => state.popupAlert)
    let { title, detailsTitle, detailsId, open, message, action, statusCode, redirect, customParam } = popupAlert;

    function handleClose() {
        dispatch(closePopup())
        switch (true) {
            case statusCode === 401:
                navigate('/account/signin');
                break;
            case title === 'success' && location.pathname === `/customer/applications/${detailsId}`:
                dispatch(getItemDetails('customer_applications', detailsId));
                break;
            case title === 'success':
                navigate(redirect ? redirect : (detailsTitle ? `/listing/${detailsTitle}` : -1))
                break;
        }
        if (popupAlert.message == 'Product Percentage deleted') {
            navigate(0);
        }
    }

    function handleDelete() {
        dispatch(deleteItemDetails(detailsTitle, detailsId))
    }

    function handleUpsert() {
        dispatch(upsertItemDetails(detailsTitle, detailsId, customParam))
    }

    const handleChange = (event) => {
        customParam = {
            ...customParam,
            [event.target.name]: event.target.value
        }
        console.log('customParam', customParam)
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title" sx={{ textTransform: 'capitalize' }}>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
                    </DialogContentText>
                    {action === 'upsert' ?
                        <TextField
                            autoFocus
                            margin="dense"
                            id='remarks'
                            name='remarks'
                            label='Remarks'
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                        /> : null}
                </DialogContent>
                <DialogActions>
                    {action === 'upsert' ?
                        <Button onClick={handleUpsert} color="primary">
                            OK
                        </Button>
                        : action === 'delete' ?
                            <Button onClick={handleDelete} color="primary">
                                OK
                            </Button>
                            : null}
                    <Button onClick={handleClose} color="primary" autoFocus>
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    )
}
